import styled from '@emotion/styled'
import { typo } from '@mathflat/common/style'
import { runInAction } from 'mobx'
import { useEffect } from 'react'

import { 가상학생목록, 김과외_가상학생목록 } from '@/constant/common'
import { academyController } from '@/controller/academy.controller'
import { studentController } from '@/controller/student.controller'
import { StudentDetail } from '@/dto'
import commonRepo from '@/repository/common.repo'
import modalService from '@/service/modal.service'
import { _mixpanelUtils } from '@/utils/trackings/_mixpanel'

export const useVirtualStudent = () => {
  useEffect(() => {
    // 가상학생 등록 로직
    // BE에서 생성하나, 생성이 안되었을 경우를 대비하여 FE도 로직을 남겨둠
    if (
      commonRepo.academy?.status === 'FREE_INPROGRESS' &&
      commonRepo.academy.studentCount === 0 &&
      commonRepo.academy?.initialized
    ) {
      const virtualStudents = Object.values(
        commonRepo.academy.customerType === 'B2B-제휴-김과외' ? 김과외_가상학생목록 : 가상학생목록,
      ).map((student) => {
        return new StudentDetail(student)
      })

      studentController
        .createVirtualStudents(virtualStudents)
        .then(async () => {
          modalService.openConfirmModal(
            {
              content: (
                <S.modal>
                  <header>문제은행을 넘어서는 경험, {commonRepo.appKorName}!</header>
                  <div className="content">
                    모든 기능을 이용하실 수 있도록 <strong>가상학생 3명</strong>을 등록해드렸어요.
                    <br />
                    (가상 학생은 무료체험 이후 자동으로 삭제됩니다.)
                  </div>
                </S.modal>
              ),
              actionButtonText: '체험 시작',
              onClick: modalService.closeModal,
              hasCancelButton: false,
            },
            { hasCloseButton: false },
          )
          const academy = await academyController.fetchMyAcademy()
          runInAction(() => {
            commonRepo.academy?.update({ ...academy, 가상학생등록여부: true })
          })
          _mixpanelUtils.uiTrack('가상학생등록완료', { academy })
        })
        .catch(() => {
          _mixpanelUtils.uiTrack('가상학생등록실패')
        })

      return
    }

    if (commonRepo.academy?.status === 'FREE_INPROGRESS' && commonRepo.academy.studentCount >= 3) {
      commonRepo.academy?.update({ 가상학생등록여부: true })
    }
  }, [commonRepo.academy, commonRepo.academy?.initialized, commonRepo.user, commonRepo.appKorName])
}

const S = {
  modal: styled.div`
    header {
      ${typo.heading05};
      font-weight: 700;
    }
    .content {
      margin-top: 10px;
    }
  `,
}
